import api from './api';

// Uygulama tarafı oda kimliğini uid'leri sıralayıp birleştirerek üretiyor.
// Panelin de aynı kuralı kullanması şart, aksi halde mesaj başka bir odaya düşer.
export const buildChatRoomId = (uid1, uid2) => [uid1, uid2].sort().join('_');

export const resolveChatRoomId = async (uid1, uid2) => {
    const fallback = buildChatRoomId(uid1, uid2);
    try {
        // Eski kayıtlarda ters sıralı oda kimlikleri olabilir; backend mevcut odayı bulur.
        const response = await api.get('/chat/rooms/resolve', { params: { uid1, uid2 } });
        return response.data?.roomId || fallback;
    } catch (e) {
        console.error('Error resolving chat room id via API:', e);
        return fallback;
    }
};
